import { Rectangle, IRectangle } from './Rectangle'
import { Arrow, IArrow } from './Arrow'
import { Elipse, IElipse } from './Elipse'
import { FreeDraw, FreeDrawStrokeType, IFreeDraw } from './FreeDraw'
import { Line, ILine } from './Line'
import {
    IDrawStyle,
    DrawType,
    DrawShape,
    IPosition
} from './Anotate'
import { ITextBox } from './TextBox'
import { IImageBox } from './Image'

export interface IBaseAnotateConfig {
  Container: HTMLDivElement;
  Width: number;
  Height: number;
  Type:'base'|'remote-user';
}
export class BaseAnotate {
  style: IDrawStyle = {
      brushColor: '#f8920f',
      brushSize: 5
  };

  canvas: HTMLCanvasElement;
  private context: CanvasRenderingContext2D;
  private _line: Line;
  private _arrow: Arrow;
  private _ellipse: Elipse;
  private _rectangle: Rectangle;
  private _freeDraw: FreeDraw;
  private _selectedTool: Line | Arrow | Elipse | Rectangle | FreeDraw;
  private _eraser: FreeDraw;
  #type:string = 'base'
  constructor (config: IBaseAnotateConfig) {
      this.canvas = document.createElement('canvas')
      this.canvas.width = config.Width
      this.canvas.height = config.Height
      config.Container.appendChild(this.canvas)
      this.context = <CanvasRenderingContext2D> this.canvas.getContext('2d')
      this.canvas.style.pointerEvents = 'none'

      if (config.Type === 'base') {
          this.canvas.classList.add('base-board')
      } else {
          this.canvas.classList.add('remote-user-board')
      }

      this._line = new Line(this.canvas, this.style)
      this._arrow = new Arrow(this.canvas, this.style)
      this._ellipse = new Elipse(this.canvas, this.style)
      this._rectangle = new Rectangle(this.canvas, this.style)
      this._freeDraw = new FreeDraw(
          this.canvas,
          FreeDrawStrokeType.DRAW,
          this.style
      )
      this._eraser = new FreeDraw(
          this.canvas,
          FreeDrawStrokeType.ERASE,
          this.style
      )
      this._selectedTool = this._line

      this.context.font = '14px Arial'
      // this.DrawShape({"style":{"brushColor":"#f8920f","brushSize":5},"type":1,"positions":[{"X":235,"Y":145},{"X":250,"Y":136},{"X":272,"Y":125},{"X":294,"Y":119},{"X":328,"Y":114},{"X":364,"Y":109},{"X":429,"Y":109},{"X":455,"Y":109},{"X":493,"Y":112},{"X":502,"Y":116},{"X":512,"Y":123},{"X":517,"Y":128},{"X":518,"Y":132},{"X":520,"Y":145},{"X":525,"Y":165},{"X":527,"Y":179},{"X":527,"Y":192},{"X":527,"Y":200},{"X":522,"Y":214},{"X":514,"Y":223},{"X":507,"Y":229},{"X":498,"Y":230},{"X":487,"Y":232},{"X":473,"Y":234},{"X":460,"Y":234},{"X":444,"Y":234},{"X":433,"Y":234},{"X":422,"Y":234},{"X":413,"Y":233},{"X":404,"Y":230},{"X":393,"Y":224},{"X":386,"Y":221},{"X":380,"Y":216},{"X":379,"Y":215},{"X":378,"Y":214},{"X":377,"Y":216},{"X":370,"Y":222},{"X":360,"Y":232},{"X":355,"Y":241},{"X":347,"Y":251},{"X":342,"Y":258},{"X":334,"Y":268},{"X":329,"Y":277},{"X":323,"Y":284},{"X":318,"Y":291},{"X":315,"Y":297},{"X":307,"Y":307},{"X":306,"Y":311},{"X":301,"Y":320},{"X":299,"Y":326},{"X":298,"Y":331},{"X":296,"Y":339},{"X":296,"Y":345},{"X":296,"Y":353},{"X":296,"Y":359},{"X":296,"Y":367},{"X":296,"Y":373},{"X":298,"Y":377},{"X":302,"Y":382},{"X":312,"Y":392},{"X":319,"Y":395},{"X":330,"Y":397},{"X":347,"Y":401},{"X":360,"Y":403},{"X":379,"Y":403},{"X":398,"Y":403},{"X":419,"Y":403},{"X":438,"Y":403},{"X":454,"Y":400},{"X":468,"Y":396},{"X":480,"Y":388},{"X":485,"Y":385},{"X":491,"Y":380},{"X":498,"Y":375},{"X":503,"Y":370},{"X":506,"Y":366},{"X":507,"Y":359},{"X":507,"Y":353},{"X":507,"Y":349},{"X":507,"Y":343},{"X":507,"Y":337},{"X":507,"Y":331},{"X":505,"Y":325},{"X":501,"Y":320},{"X":488,"Y":308},{"X":474,"Y":297},{"X":454,"Y":289},{"X":435,"Y":284},{"X":416,"Y":282},{"X":402,"Y":280},{"X":389,"Y":280},{"X":373,"Y":280},{"X":358,"Y":285},{"X":341,"Y":294},{"X":327,"Y":302},{"X":310,"Y":315},{"X":295,"Y":326},{"X":283,"Y":336},{"X":270,"Y":346},{"X":261,"Y":356},{"X":251,"Y":364},{"X":242,"Y":367},{"X":237,"Y":372},{"X":231,"Y":375},{"X":224,"Y":380},{"X":223,"Y":382},{"X":217,"Y":383},{"X":216,"Y":384},{"X":215,"Y":385},{"X":160,"Y":93},{"X":179,"Y":84},{"X":204,"Y":77},{"X":238,"Y":70},{"X":267,"Y":68},{"X":306,"Y":60},{"X":346,"Y":57},{"X":428,"Y":57},{"X":485,"Y":57},{"X":509,"Y":63},{"X":531,"Y":74},{"X":543,"Y":80},{"X":553,"Y":88},{"X":567,"Y":96},{"X":579,"Y":109},{"X":589,"Y":118},{"X":595,"Y":130}]});
      // this.DrawShape({"style":{"brushColor":"#f8920f","brushSize":5},"type":1,"positions":[{"X":145,"Y":145},{"X":136,"Y":136},{"X":125,"Y":125},{"X":119,"Y":119},{"X":114,"Y":114},{"X":109,"Y":109}]});
  }

  DrawShape = (shape: DrawShape) => {
      try {
      // console.log("received " + shape.type);
          if (shape.Type === DrawType.Line) {
              this._line.Draw(<ILine>shape)
          } else if (shape.Type === DrawType.Arrow) {
              this._arrow.Draw(<IArrow>shape)
          } else if (shape.Type === DrawType.Elipse) {
              this._ellipse.Draw(<IElipse>shape)
          } else if (shape.Type === DrawType.Rectangle) {
              this._rectangle.Draw(<IRectangle>shape)
          } else if (shape.Type === DrawType.FreeDraw) {
              this._freeDraw.Draw(<IFreeDraw>shape)
          } else if (shape.Type === DrawType.Eraser) {
              this._eraser.Draw(<IFreeDraw>shape)
          } else if (shape.Type === DrawType.Image) {
              this.DrawImage(<IImageBox><unknown>shape)
          } else if (shape.Type === DrawType.Textbox) {
              this.DrawText(<ITextBox><unknown>shape)
          }
      } catch (ex) {
          console.log('redrawAnnotations', ex)
      }
  };

  StartDrawing (shape: DrawShape) {
      let x: number = 0
      let y: number = 0
      if (shape.Type === DrawType.FreeDraw) {
          const freeDraw = <IFreeDraw>shape
          this._selectedTool = this._freeDraw
          x = freeDraw.Positions[0].X
          y = freeDraw.Positions[0].Y
      } else if (shape.Type === DrawType.Elipse) {
          const elipse = <IElipse>shape
          this._selectedTool = this._ellipse
          x = elipse.X1
          y = elipse.Y1
      } else if (shape.Type === DrawType.Rectangle) {
          const rectangle = <IRectangle>shape
          this._selectedTool = this._rectangle
          x = rectangle.X1
          y = rectangle.Y1
      } else if (shape.Type === DrawType.Arrow) {
          const arrow = <IArrow>shape
          this._selectedTool = this._arrow
          x = arrow.X1
          y = arrow.Y1
      } else if (shape.Type === DrawType.Line) {
          const line = <ILine>shape
          this._selectedTool = this._line
          x = line.X1
          y = line.Y1
      } else if (shape.Type === DrawType.Eraser) {
          const freeDraw = <IFreeDraw>shape
          this._selectedTool = this._eraser
          x = freeDraw.Positions[0].X
          y = freeDraw.Positions[0].Y
      }
      this._selectedTool.StartDrawing(shape.Style, { X: x, Y: y })
  }

  UpdatePositions (pos: IPosition) {
      this._selectedTool.UpdatePositions(pos)
  }

  FinishDrawing (pos: IPosition) {
      this._selectedTool.FinishDrawing(pos)
  }

  Dispose () {
      this.canvas.remove()
  }

  GetShape (): DrawShape {
      return this._selectedTool.GetShape()
  }

  Clear () {
      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
  }

  DrawImage (imagebox: IImageBox) {
      // image: HTMLImageElement, pos: IPosition, shape: ISize) {
      const image = document.createElement('img')
      image.src = imagebox.ImageData
      image.onload = () => {
          this.context.drawImage(
              image,
              imagebox.Pos.X,
              imagebox.Pos.Y,
              imagebox.Shape.Width,
              imagebox.Shape.Height
          )
          image.remove()
      }
  }

  DrawText (textbox: ITextBox) {
      // } text: string, pos: IPosition, shape: ISize) {
      this.WrapText(
          this.context,
          textbox.Text,
          textbox.Pos.X,
          textbox.Pos.Y,
          textbox.Shape.Width,
          25
      )
  }

  Display (type: boolean) {
      if (type) {
          this.canvas.style.display = 'block'
      } else {
          this.canvas.style.display = 'none'
      }
  }

  private WrapText (
      context: CanvasRenderingContext2D,
      text: string,
      x: number,
      y: number,
      maxWidth: number,
      lineHeight: number
  ) {
      const words = text.split(' ')
      let line = ''
      y += 50
      maxWidth += 50
      for (let n = 0; n < words.length; n++) {
          const testLine = line + words[n] + ' '
          const metrics = context.measureText(testLine)
          const testWidth = metrics.width
          if (testWidth > maxWidth && n > 0) {
              context.fillText(line, x, y)
              line = words[n] + ' '
              y += lineHeight
          } else {
              line = testLine
          }
      }
      context.fillText(line, x, y)
  }

  changeSize = (width: number, height: number) => {
      this.canvas.width = width
      this.canvas.height = height
  }
}
